import React, { useEffect } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import AnalyticsDashboard from './pages/analytics-dashboard';
import ServiceCatalogManager from './pages/service-catalog-manager';
import DispatchControlCenter from './pages/dispatch-control-center';
import InventoryManagement from './pages/inventory-management';
import PublicServiceTracking from './pages/public-service-tracking';
import LoginAuthentication from './pages/login-authentication';
import ServiceBookingWizard from './pages/service-booking-wizard';
import TechnicianDailyRoutes from './pages/technician-daily-routes';
import CustomerAccountPortal from './pages/customer-account-portal';
import AuthCallback from './pages/auth-callback';
import PrivacyPolicy from './pages/privacy-policy';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
          <Route path="/service-catalog-manager" element={<ServiceCatalogManager />} />
          <Route path="/dispatch-control-center" element={<DispatchControlCenter />} />
          <Route path="/inventory-management" element={<InventoryManagement />} />
          <Route path="/public-service-tracking" element={<PublicServiceTracking />} />
          <Route path="/login-authentication" element={<LoginAuthentication />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/service-booking-wizard" element={<ServiceBookingWizard />} />
          <Route path="/technician-daily-routes" element={<TechnicianDailyRoutes />} />
          <Route path="/customer-account-portal" element={<CustomerAccountPortal />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default AppRoutes;
// Named export that uses AppRoutes
const Routes = AppRoutes;

export { Routes };